import { Wordmark } from '../../components/Wordmark';

type Props = {
  message?: string;
  accent: string;
};

export function LoadingSplash({ message = 'Loading…', accent }: Props) {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--cream)',
        display: 'grid',
        placeItems: 'center',
        position: 'relative',
      }}
    >
      <div style={{ position: 'absolute', top: 28, left: 36 }}>
        <Wordmark size={18} />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 18 }}>
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: '50%',
            border: `2.5px solid ${accent}33`,
            borderTopColor: accent,
            animation: 'spin 1s linear infinite',
          }}
        />
        <div className="mono" style={{ color: 'rgba(14,14,14,.6)' }}>
          {message}
        </div>
      </div>
    </div>
  );
}
